// DataQuery.ts
import { IResultAndError, getObjectWithApiError } from "../ChoiceApi";
import { IQueryColumns, IQuerySearchResponse, IQueryTotalResponse } from "../Models/DataQueryModel";

export async function getTotals(tableViewId : number, searchID : number, ignoreDefaults: boolean): Promise<IResultAndError<IQueryTotalResponse>>{  
    const url = `api/DataQueries/GetTotals/${tableViewId}/${searchID}/${ignoreDefaults}`;
    return getObjectWithApiError<IQueryTotalResponse>(url);
}
export async function getResults(tableViewId : number, searchID : number,searchText: string, ignoreDefaults: boolean): Promise<IResultAndError<IQuerySearchResponse>>{  
    const url = `api/DataQueries/GetResults?tableViewId=${tableViewId}&searchID=${searchID}&searchText=${encodeURI(searchText)}&IgnoreDefaults=${ignoreDefaults}`;
    return getObjectWithApiError<IQuerySearchResponse>(url);
}

export async function getColumnInfo(tableViewId : number): Promise<IResultAndError<IQueryColumns[]>>{  
    return getObjectWithApiError<IQueryColumns[]>(`api/DataQueries/Columns/${tableViewId}`);
}
